export default (element: Element, callback: CallableFunction) => {
  const transitionProperty = getComputedStyle(element).getPropertyValue('transition-duration');
  const hasDuration = parseFloat(transitionProperty || '0') !== 0;

  if (!hasDuration) {
    callback();

    return;
  }

  Promise.allSettled(element.getAnimations().map((animation) => animation.finished)).then(() => {
    callback();
  });
};
